/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ToolbarDockAPI
 * @hideconstructor
 * @classdesc API class that is used to manage the Toolbar Dock.
 */
define([], () => {
	class ToolbarDockAPI {

		/**
		 * @function ToolbarDockAPI#updateODTState
		 * @description Render a toolbar for the supplied spec in the content dock toolbar
		 * @param {Object[]} actions - The toolbar spec to render
		 * @param {String[]} [selectedIds] - Array of selected widget ids. Undefined is a valid value if the toolbar acts on a sub-control rather than a widget, such as the text toolbar.
		 */
		updateODTState(/*actions, selectedIds*/){}

		/**
		 * @function ToolbarDockAPI#focusODT
		 * @description Focus on the ODT
		 */
		focusODT(){}

		/**
		 * @function ToolbarDock#getOwnerIDs
		 * @description Get the IDs of the contents that the current ODT is displayed for
		 * @return {String[]} an array of IDs of contents
		 */
		getOwnerIDs(){}
	}

	/* Callback IDs */

	/**
	 * @public
	 * @readonly
	 * @description Callback id for the docked toolbar section
	 * @memberof ToolbarDockAPI
	 */
	ToolbarDockAPI.UPDATE_DOCKED_TOOLBAR_STATE = 'updateState_dockedToolbar';

	/**
	 * @public
	 * @readonly
	 * @description Callback id for the canvas toolbar section
	 * @memberof ToolbarDockAPI
	 */
	ToolbarDockAPI.UPDATE_CANVAS_TOOLBAR_STATE = 'updateState_canvasToolbar';

	/**
	 * @public
	 * @readonly
	 * @description Callback id for the docked toolbar section
	 * @memberof ToolbarDockAPI
	 */
	ToolbarDockAPI.FOCUS_DOCKED_TOOLBAR = 'focus_dockedToolbar';

	return ToolbarDockAPI;
});
